/**
 * The tile that opens a draft in the side panel, from the prototype's
 * artifact card (lines ~113-119). The glyph names what is inside without
 * opening it: a checklist for a quiz, a page for markdown.
 */

import { Ph } from '../ui';
import type { CardProps } from './types';

export function ArtifactCard({ message, onOpenArtifact }: CardProps) {
  if (message.body.kind !== 'artifact') return null;
  const { title, subtitle, doc } = message.body;
  const icon = doc.type === 'quiz' ? 'list-checks' : 'file-text';

  return (
    <button
      type="button"
      className="bare hov-lift"
      onClick={() => onOpenArtifact(message)}
      style={{
        alignSelf: 'flex-start',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 16px 12px 12px',
        borderRadius: 'var(--radius-app-card)',
        background: 'var(--surface-card)',
        minWidth: 280
      }}
    >
      <span
        style={{
          width: 36,
          height: 36,
          flex: 'none',
          borderRadius: 9,
          background: 'var(--primary-soft)',
          color: 'var(--primary)',
          display: 'grid',
          placeItems: 'center'
        }}
      >
        <Ph name={icon} size={18} />
      </span>
      <span style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-strong)' }}>{title}</span>
        <span style={{ fontSize: 12.5, color: 'var(--text-muted)' }}>{subtitle}</span>
      </span>
      <Ph name="arrow-up-right" size={15} color="var(--text-muted)" />
    </button>
  );
}
